/*------ ITG Ck of Js 30-06-2023------ */
$(document).ready(function() {
  
   var genrate_blank = `<table>
    <thead>
      <th style="text-transform: capitalize;">Item<br/></th>
      <th style="text-transform: capitalize;">Calories <br/><span style="text-transform: lowercase"></span></th>
      <th style="text-transform: capitalize;">Protein <br/><span style="text-transform: lowercase">(g)</span></th>
      <th style="text-transform: capitalize;">Carbs <br/><span style="text-transform: lowercase">(g)</span></th>
      <th style="text-transform: capitalize;">Fats <br/><span style="text-transform: lowercase">(g)</span></th>
      <th style="text-transform: capitalize;">Sodium <br/><span style="text-transform: lowercase">(mg)</span></th>
      <th style="text-transform: capitalize;">fiber <br/><span style="text-transform: lowercase">(g)</span></th>
    </thead>
    <tbody class="data_nutritionData_ck">
    <tbody>
    <tfoot class="total_calcultion_nutritionData_ck">
      <th style="text-transform: capitalize;">Total</th>
      <th></th>
      <th></th>
      <th></th>
      <th></th>
      <th></th>
      <th></th>
    </tfoot>
    </table>`;

    $('#nutrition-container').html(genrate_blank);
    $('#nutrition-container').hide();
    $('.data_nutritionData_ck').html('');
 
     $(document).on('change','.bold_option.bold_option_swatch input[type="checkbox"],select[name="properties[Add seasoning?]"]',function() {
      var nutritionFact = {
        /* Carb */
        "White Rice 1/4": {
          "calorie": 39,
          "protein": 1,
          "carb": 8,
          "fats": 0,
          "sodium": 1,
          "fiber":0
        },
       "White Rice 1/2": {
          "calorie": 77,
          "protein": 2,
          "carb": 17,
          "fats": 0,
          "sodium": 2,
          "fiber":0
        },
         "White Rice 3/4": {
          "calorie": 166,
          "protein": 2.75,
          "carb": 25,
          "fats": 0,
          "sodium": 3,
          "fiber":0
        },
         "White Rice 1": {
          "calorie": 180,
          "protein": 4,
          "carb": 38,
          "fats": 0,
          "sodium": 5,
          "fiber":0
        },

         "Brown Rice 1/4": {
          "calorie": 52,
          "protein": 1,
          "carb": 11,
          "fats": 0,
          "sodium": 2,
          "fiber":0
        },
       "Brown Rice 1/2": {
          "calorie": 103,
          "protein": 2,
          "carb": 22,
          "fats": 1,
          "sodium": 4,
          "fiber":0
        },
         "Brown Rice 3/4": {
          "calorie": 155,
          "protein": 3,
          "carb": 33,
          "fats": 1,
          "sodium": 5,
          "fiber":1
        },
         "Brown Rice 1": {
          "calorie": 207,
          "protein": 4,
          "carb": 44,
          "fats": 1.5,
          "sodium": 7,
          "fiber":2
        },


        "Diced Potato 1/4": {
          "calorie": 37,
          "protein": 1,
          "carb": 7,
          "fats": 1,
          "sodium": 14,
          "fiber":0
        },
       "Diced Potato 1/2": {
          "calorie": 73,
          "protein": 2,
          "carb": 14,
          "fats": 1.5,
          "sodium": 28,
          "fiber":1
        },
         "Diced Potato 3/4": {
          "calorie": 110,
          "protein": 2,
          "carb": 20,
          "fats": 2.5,
          "sodium": 42,
          "fiber":2
        },
         "Diced Potato 1": {
          "calorie": 146,
          "protein": 3,
          "carb": 27,
          "fats": 3,
          "sodium": 57,
          "fiber":3
        },

        
        "Wild Rice 1/4": {
          "calorie": 45,
          "protein": 2,
          "carb": 9,
          "fats": 0,
          "sodium": 2,
          "fiber":0
        },
       "Wild Rice 1/2": {
          "calorie": 89,
          "protein": 4,
          "carb": 19,
          "fats": 0,
          "sodium": 3,
          "fiber":1
        },
         "Wild Rice 3/4": {
          "calorie": 134,
          "protein": 6,
          "carb": 28,
          "fats": 0,
          "sodium": 5,
          "fiber":2
        },
         "Wild Rice 1": {
          "calorie": 179,
          "protein": 7,
          "carb": 38,
          "fats": 0.5,
          "sodium": 7,
          "fiber":3
        },

        
        "Mashed Coconut Sweet Potato 1/4": {
          "calorie": 76,
          "protein": 1,
          "carb": 17,
          "fats": 0.5,
          "sodium": 12,
          "fiber":2
        },
       "Mashed Coconut Sweet Potato 1/2": {
          "calorie": 152,
          "protein": 2,
          "carb": 34,
          "fats": 1,
          "sodium": 23,
          "fiber":5
        },
         "Mashed Coconut Sweet Potato 3/4": {
          "calorie": 228,
          "protein": 3,
          "carb": 51,
          "fats": 1.5,
          "sodium": 35,
          "fiber":7
        },
         "Mashed Coconut Sweet Potato 1": {
          "calorie": 303,
          "protein": 3,
          "carb": 68,
          "fats": 2,
          "sodium": 47,
          "fiber":10
        },

        /* Protien */
        
        "Chicken Breast 3": {
          "calorie": 140,
          "protein": 26,
          "carb": 0,
          "fats": 3,
          "sodium": 63,
          "fiber":0
        },
         "Chicken Breast 4": {
          "calorie": 187,
          "protein": 35,
          "carb": 0,
          "fats": 4,
          "sodium": 84,
          "fiber":0
        },
         "Chicken Breast 5": {
          "calorie": 233,
          "protein": 44,
          "carb": 0,
          "fats": 5,
          "sodium": 105,
          "fiber":0
        },
           "Chicken Breast 6": {
          "calorie": 280,
          "protein": 53,
          "carb": 0,
          "fats": 6,
          "sodium": 126,
          "fiber":0
        },
          "Chicken Breast 7": {
          "calorie": 327,
          "protein": 61,
          "carb": 0,
          "fats": 7,
          "sodium": 147,
          "fiber":0
        },
          "Chicken Breast 8": {
          "calorie": 327,
          "protein": 70,
          "carb": 0,
          "fats": 8,
          "sodium": 168,
          "fiber":0
        },
        "Smoked Chicken Breast 3": {
          "calorie": 140,
          "protein": 26,
          "carb": 0,
          "fats": 3,
          "sodium": 63,
          "fiber":0
        },
         "Smoked Chicken Breast 4": {
          "calorie": 187,
          "protein": 35,
          "carb": 0,
          "fats": 4,
          "sodium": 84,
          "fiber":0
        },
         "Smoked Chicken Breast 5": {
          "calorie": 233,
          "protein": 44,
          "carb": 0,
          "fats": 5,
          "sodium": 105,
          "fiber":0
        },
           "Smoked Chicken Breast 6": {
          "calorie": 280,
          "protein": 53,
          "carb": 0,
          "fats": 6,
          "sodium": 126,
          "fiber":0
        },
          "Smoked Chicken Breast 7": {
          "calorie": 327,
          "protein": 61,
          "carb": 0,
          "fats": 7,
          "sodium": 147,
          "fiber":0
        },
          "Smoked Chicken Breast 8": {
          "calorie": 327,
          "protein": 70,
          "carb": 0,
          "fats": 8,
          "sodium": 168,
          "fiber":0
        },

        "Chicken Thigh 3": {
          "calorie": 148,
          "protein": 22,
          "carb": 0,
          "fats": 6,
          "sodium": 73,
          "fiber":0
        },
         "Chicken Thigh 4": {
          "calorie": 197,
          "protein": 30,
          "carb": 0,
          "fats": 8,
          "sodium": 97,
          "fiber":0
        },
         "Chicken Thigh 5": {
          "calorie": 246,
          "protein": 37,
          "carb": 1,
          "fats": 10,
          "sodium": 121,
          "fiber":0
        },
           "Chicken Thigh 6": {
          "calorie": 295,
          "protein": 45,
          "carb": 1,
          "fats": 12,
          "sodium": 146,
          "fiber":0
        },
          "Chicken Thigh 7": {
          "calorie": 345,
          "protein": 52,
          "carb": 1,
          "fats": 15,
          "sodium": 170,
          "fiber":0
        },
          "Chicken Thigh 8": {
          "calorie": 394,
          "protein": 60,
          "carb": 1,
          "fats": 17,
          "sodium": 194,
          "fiber":0
        },

          "Flank Steak 3": {
           "calorie":142,
          "protein":22,
          "carb":0,
          "fats":7,
          "sodium":180,
          "fiber":0
        },
         "Flank Steak 4": {
          "calorie": 190,
          "protein": 29,
          "carb": 0,
          "fats": 9,
          "sodium": 241,
          "fiber":0
        },
         "Flank Steak 5": {
          "calorie": 237,
          "protein": 37,
          "carb": 0,
          "fats": 11,
          "sodium": 301,
          "fiber":0
        },
           "Flank Steak 6": {
          "calorie": 285,
          "protein": 44,
          "carb": 0,
          "fats": 14,
          "sodium": 361,
          "fiber":0
        },
          "Flank Steak 7": {
          "calorie": 332,
          "protein": 52,
          "carb": 0,
          "fats": 16,
          "sodium": 421,
          "fiber":0
        },
          "Flank Steak 8": {
          "calorie": 380,
          "protein": 59,
          "carb": 0,
          "fats": 18,
          "sodium": 481,
          "fiber":0
        },


        "Ground Beef 3": {
           "calorie":209,
          "protein":22,
          "carb":2,
          "fats":13,
          "sodium":295,
          "fiber":0
        },
         "Ground Beef 4": {
          "calorie": 279,
          "protein": 30,
          "carb": 0,
          "fats": 17,
          "sodium": 393,
          "fiber":0
        },
         "Ground Beef 5": {
          "calorie": 349,
          "protein": 37,
          "carb": 0,
          "fats": 21,
          "sodium": 491,
          "fiber":0
        },
           "Ground Beef 6": {
          "calorie": 419,
          "protein": 45,
          "carb": 0,
          "fats": 25,
          "sodium": 589,
          "fiber":0
        },
          "Ground Beef 7": {
          "calorie": 489,
          "protein": 52,
          "carb": 0,
          "fats": 29,
          "sodium": 687,
          "fiber":0
        },
          "Ground Beef 8": {
          "calorie": 559,
          "protein": 60,
          "carb": 0,
          "fats": 34,
          "sodium": 785,
          "fiber":0
        },


        "Shredded Beef 3": {
           "calorie":124,
          "protein":22,
          "carb":0,
          "fats":4,
          "sodium":72,
          "fiber":0
        },
         "Shredded Beef 4": {
          "calorie": 166,
          "protein": 29,
          "carb": 0,
          "fats": 5,
          "sodium": 96,
          "fiber":0
        },
         "Shredded Beef 5": {
          "calorie": 207,
          "protein": 37,
          "carb": 0,
          "fats": 6,
          "sodium": 120,
          "fiber":0
        },
           "Shredded Beef 6": {
          "calorie": 249,
          "protein": 44,
          "carb": 0,
          "fats": 8,
          "sodium": 144,
          "fiber":0
        },
          "Shredded Beef 7": {
          "calorie": 290,
          "protein": 51,
          "carb": 0,
          "fats": 9,
          "sodium": 168,
          "fiber":0
        },
          "Shredded Beef 8": {
          "calorie": 332,
          "protein": 59,
          "carb": 0,
          "fats": 10,
          "sodium": 192,
          "fiber":0
        },

         "Turkey Breast 3": {
           "calorie":123,
          "protein":27,
          "carb":0,
          "fats":2,
          "sodium":55,
          "fiber":0
        },
         "Turkey Breast 4": {
          "calorie": 164,
          "protein": 35,
          "carb": 0,
          "fats": 2.5,
          "sodium": 74,
          "fiber":0
        },
         "Turkey Breast 5": {
          "calorie": 205,
          "protein": 44,
          "carb": 0,
          "fats": 3,
          "sodium": 92,
          "fiber":0
        },
         "Turkey Breast 6": {
          "calorie": 246,
          "protein": 53,
          "carb": 0,
          "fats": 3.5,
          "sodium": 111,
          "fiber":0
        },
          "Turkey Breast 7": {
          "calorie": 287,
          "protein": 62,
          "carb": 0,
          "fats": 4,
          "sodium": 129,
          "fiber":0
        },
          "Turkey Breast 8": {
          "calorie": 328,
          "protein": 71,
          "carb": 0,
          "fats": 5,
          "sodium": 148,
          "fiber":0
          },

        "Smoked Turkey Breast 3": {
           "calorie":123,
          "protein":27,
          "carb":0,
          "fats":2,
          "sodium":55,
          "fiber":0
        },
         "Smoked Turkey Breast 4": {
          "calorie": 164,
          "protein": 35,
          "carb": 0,
          "fats": 2.5,
          "sodium": 74,
          "fiber":0
        },
         "Smoked Turkey Breast 5": {
          "calorie": 205,
          "protein": 44,
          "carb": 0,
          "fats": 3,
          "sodium": 92,
          "fiber":0
        },
         "Smoked Turkey Breast 6": {
          "calorie": 246,
          "protein": 53,
          "carb": 0,
          "fats": 3.5,
          "sodium": 111,
          "fiber":0
        },
          "Smoked Turkey Breast 7": {
          "calorie": 287,
          "protein": 62,
          "carb": 0,
          "fats": 4,
          "sodium": 129,
          "fiber":0
        },
          "Smoked Turkey Breast 8": {
          "calorie": 328,
          "protein": 71,
          "carb": 0,
          "fats": 5,
          "sodium": 148,
          "fiber":0
          },


         "Ground Turkey 3": {
           "calorie":214,
          "protein":22,
          "carb":0,
          "fats":14,
          "sodium":75,
          "fiber":0
        },
         "Ground Turkey 4": {
          "calorie": 286,
          "protein": 30,
          "carb": 0,
          "fats": 18,
          "sodium": 99,
          "fiber":0
        },
         "Ground Turkey 5": {
          "calorie": 357,
          "protein": 37,
          "carb": 0,
          "fats": 23,
          "sodium": 124,
          "fiber":0
        },
         "Ground Turkey 6": {
          "calorie": 429,
          "protein": 45,
          "carb": 0,
          "fats": 28,
          "sodium": 149,
          "fiber":0
        },
          "Ground Turkey 7": {
          "calorie": 500,
          "protein": 52,
          "carb": 0,
          "fats": 32,
          "sodium": 174,
          "fiber":0
        },
          "Ground Turkey 8": {
          "calorie": 572,
          "protein": 60,
          "carb": 0,
          "fats": 37,
          "sodium": 199,
          "fiber":0
          },


        /// veg 
         "Green Beans 1/4": {
          "calorie": 10,
          "protein": 1,
          "carb": 2,
          "fats": 0,
          "sodium": 0,
          "fiber":0
          },
          "Green Beans 1/2": {
          "calorie": 20,
          "protein": 1,
          "carb": 5,
          "fats": 0,
          "sodium": 0,
          "fiber":1
          },
        "Green Beans 3/4": {
          "calorie": 35,
          "protein": 2,
          "carb": 7,
          "fats": 0,
          "sodium": 0,
          "fiber":2
          },
          "Green Beans 1": {
          "calorie": 45,
          "protein": 2,
          "carb": 10,
          "fats": 0,
          "sodium": 0,
          "fiber":3
          },


        "Brocolli 1/4": {
          "calorie": 15,
          "protein": 1,
          "carb": 3,
          "fats": 0,
          "sodium": 15,
          "fiber":0
          },
          "Brocolli 1/2": {
          "calorie": 25,
          "protein": 2,
          "carb": 6,
          "fats": 0,
          "sodium": 30,
          "fiber":1
          },
        "Brocolli 3/4": {
          "calorie": 40,
          "protein": 3,
          "carb": 8,
          "fats": 0,
          "sodium": 50,
          "fiber":2
          },
          "Brocolli 1": {
          "calorie": 50,
          "protein": 4,
          "carb": 11,
          "fats": 0.5,
          "sodium": 65,
          "fiber":2
          },


         "Brussel Sprouts 1/4": {
          "calorie": 15,
          "protein": 1,
          "carb": 3,
          "fats": 0,
          "sodium": 10,
          "fiber":0
          },
          "Brussel Sprouts 1/2": {
          "calorie": 30,
          "protein": 2,
          "carb": 6,
          "fats": 0,
          "sodium": 15,
          "fiber":1
          },
          "Brussel Sprouts 3/4": {
          "calorie": 40,
          "protein": 3,
          "carb": 8,
          "fats": 0.5,
          "sodium": 25,
          "fiber":2
          },
          "Brussel Sprouts 1": {
            "calorie": 60,
            "protein": 4,
            "carb": 11,
            "fats": 1,
            "sodium": 35,
            "fiber":3
          },

         "Cauliflower 1/4": {
          "calorie": 5,
          "protein": 1,
          "carb": 1,
          "fats": 0,
          "sodium": 0,
          "fiber":0
          },
          "Cauliflower 1/2": {
          "calorie": 15,
          "protein": 1,
          "carb": 3,
          "fats": 0,
          "sodium": 10,
          "fiber":1
          },
          "Cauliflower 3/4": {
          "calorie": 20,
          "protein": 2,
          "carb": 4,
          "fats": 0,
          "sodium": 15,
          "fiber":2
          },
          "Cauliflower 1": {
            "calorie": 30,
            "protein": 2,
            "carb": 5,
            "fats": 0.5,
            "sodium": 20,
            "fiber":2
          },

                 
          "Zoodles 1/4": {
          "calorie": 5,
          "protein": 0,
          "carb": 1,
          "fats": 0,
          "sodium": 0,
          "fiber":0
          },
          "Zoodles 1/2": {
          "calorie": 10,
          "protein": 1,
          "carb": 2,
          "fats": 0,
          "sodium": 0,
          "fiber":0
          },
          "Zoodles 3/4": {
          "calorie": 15,
          "protein": 1,
          "carb": 3,
          "fats": 0,
          "sodium": 5,
          "fiber":0
          },
          "Zoodles 1": {
            "calorie": 20,
            "protein": 2,
            "carb": 4,
            "fats": 0,
            "sodium": 10,
          "fiber":0
          }, 


        
        "Mashed-Coconut Sweet-Potato 1/4": {
          "calorie": 76,
          "protein": 1,
          "carb": 17,
          "fats": 0.5,
          "sodium": 12,
          "fiber":0
        },
        "Mashed-Coconut Sweet-Potato 1/2": {
          "calorie": 152,
          "protein": 2,
          "carb": 34,
          "fats": 1,
          "sodium": 23,
          "fiber":0
        },
         "Mashed-Coconut Sweet-Potato 3/4": {
          "calorie": 228,
          "protein": 3,
          "carb": 51,
          "fats": 1.5,
          "sodium": 35,
          "fiber":0
        },
         "Mashed-Coconut Sweet-Potato 1": {
          "calorie": 303,
          "protein": 3,
          "carb": 68,
          "fats": 2,
          "sodium": 47,
          "fiber":0
        },


          // Sourc
           "Nashville sauce": {
            "calorie": 35,
            "protein": 0,
            "carb": 1,
            "fats": 3.5,
            "sodium": 600,
          "fiber":0
          },
          "Chili verde": {
          "calorie": 10,
          "protein": 0,
          "carb": 2,
          "fats": 0,
          "sodium": 180,
          "fiber":0
        }, 
        "Poutine (Dairy)": {
          "calorie": 10,
          "protein": 0,
          "carb": 2,
          "fats": 0,
          "sodium": 0,
          "fiber":0
        },
        "NA": {
          "calorie": 0,
          "protein": 0,
          "carb": 0,
          "fats": 0,
          "sodium": 0,
          "fiber":0
        }
      } // end of nutritinoFact

    setTimeout(function() {
        $('#nutrition-container').hide();
        $('.data_nutritionData_ck').html('');
        $('.total_calcultion_nutritionData_ck').html('');
        var total_calorie = 0;
        var total_protein = 0;
        var total_carb = 0;
        var total_fats = 0;
        var total_sodium = 0;
        var total_fiber = 0;
        $(document).find('.bold_options[data-product-id] .bold_option_set').each(function(index) {
            var option_title_value = $(this).find('label .bold_option_title').text().trim();
            var this_option_selection_value = $(this).find('.bold_option_element select').val();
            var this_option_selection_value_only_s = $('[name="properties[Add seasoning?]"]').val();
            var swach_value_selected = $(this).find('.bold_option_element input:checked').val();
            var swach_value_selected_checkbox_ = $(this).find('.bold_option_element input').length;
            var swach_value_selected_check = $(this).find('.bold_option_element input:checked').length;

          
          if (this_option_selection_value != '' && swach_value_selected_check != 0) {
            var swach_value_selected = swach_value_selected.replace(/oz|Cup/gi,'').toLocaleLowerCase();
            var swach_value_selected = swach_value_selected.trim();
            var nutritionFact_finder = this_option_selection_value+' '+swach_value_selected;

            total_calorie += nutritionFact[nutritionFact_finder]['calorie'];
            total_protein += nutritionFact[nutritionFact_finder]['protein'];
            total_carb += nutritionFact[nutritionFact_finder]['carb'];
            total_fats += nutritionFact[nutritionFact_finder]['fats'];
            total_sodium += nutritionFact[nutritionFact_finder]['sodium'];  
            total_fiber += nutritionFact[nutritionFact_finder]['fiber'];   
            var nutritionData = `
                            <tr>
                              <td class="item">${(this_option_selection_value)}</td>
                              <td>${nutritionFact[nutritionFact_finder]['calorie']}</td>
                              <td>${nutritionFact[nutritionFact_finder]['protein']}</td>
                              <td>${nutritionFact[nutritionFact_finder]['carb']}</td>
                              <td>${nutritionFact[nutritionFact_finder]['fats']}</td>
                              <td>${nutritionFact[nutritionFact_finder]['sodium']}</td>
                              <td>${nutritionFact[nutritionFact_finder]['fiber']}</td>
                            </tr>
                        `;
            if (option_title_value == 'Protein*') {
              $('.data_nutritionData_ck').prepend(nutritionData);
            } else {
              $('.data_nutritionData_ck').append(nutritionData);
            }
              $('#nutrition-container').show();   
        }
        if ( this_option_selection_value_only_s != '' && index == 2) {
                    var nutritionFact_finder = this_option_selection_value_only_s;
                    total_calorie += nutritionFact[nutritionFact_finder]['calorie'];
                    total_protein += nutritionFact[nutritionFact_finder]['protein'];
                    total_carb += nutritionFact[nutritionFact_finder]['carb'];
                    total_fats += nutritionFact[nutritionFact_finder]['fats'];
                    total_sodium += nutritionFact[nutritionFact_finder]['sodium'];
                    total_fiber += nutritionFact[nutritionFact_finder]['fiber'];   
                    var nutritionData = `<tr>
                                          <td class="item">${(this_option_selection_value_only_s)}</td>
                                          <td>${nutritionFact[nutritionFact_finder]['calorie']}</td>
                                          <td>${nutritionFact[nutritionFact_finder]['protein']}</td>
                                          <td>${nutritionFact[nutritionFact_finder]['carb']}</td>
                                          <td>${nutritionFact[nutritionFact_finder]['fats']}</td>
                                          <td>${nutritionFact[nutritionFact_finder]['sodium']}</td>
                                          <td>${nutritionFact[nutritionFact_finder]['fiber']}</td>
                                        </tr> `;
                if (option_title_value == 'Protein*') {
                  $('.data_nutritionData_ck').prepend(nutritionData);
                } else {
                  $('.data_nutritionData_ck').append(nutritionData);
                }
                $('#nutrition-container').show();         
        }
      }).promise().done(function() {
                        var total_nutration_deta = `
                            <th style="text-transform: capitalize;">Total</th>
                              <th>${(total_calorie)}</th>
                              <th>${(total_protein)}</th>
                              <th>${(total_carb)}</th>
                              <th>${(total_fats)}</th>
                              <th>${(total_sodium)}</th>
                              <th>${(total_fiber)}</th>
                        `;
                         $('.total_calcultion_nutritionData_ck').append(total_nutration_deta);
          $('.ItgNutrition').html(`
			<input required class="required" id="custom-location" type="hidden" name="properties[Total Calories]" value="${(total_calorie)}">
			<input required class="required" id="custom-location" type="hidden" name="properties[Total Protein]" value="${(total_protein)}">
			<input required class="required" id="custom-location" type="hidden" name="properties[Total Carbs]" value="${(total_carb)}">
			<input required class="required" id="custom-location" type="hidden" name="properties[Total Fats]" value="${(total_fats)}">
			<input required class="required" id="custom-location" type="hidden" name="properties[Total Sodium]" value="${(total_sodium)}">
       	    <input required class="required" id="custom-location" type="hidden" name="properties[Total Fiber]" value="${(total_fiber)}">
            `)
     });
    },300);
  });
}); 